import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', component: () => import('@/views/Intro'), name: 'intro' },
    { path: '/login', component: () => import('@/views/Account/Login'), name: 'login' },
    { path: '/signup', component: () => import('@/views/Account/Signup'), name: 'signup' },
    { path: '/sns', component: () => import('@/views/Account/Sns'), name: 'sns' },
    { path: '/terms', component: () => import('@/views/Common/Terms'), name: 'terms' },
    { path: '/findaccount', component: () => import('@/views/Account/Findaccount'), name: 'findaccount' },
    { path: '/findid', component: () => import('@/views/Account/Findid'), name: 'findid' },
    { path: '/resetpassword', component: () => import('@/views/Account/Resetpassword'), name: 'resetpassword' },
    { path: '/index', component: () => import('@/views/Main/Index'), name: 'index' },
    { path: '/home', component: () => import('@/views/Main/Home/Home'), name: 'home' },
    { path: '/live', component: () => import('@/views/Main/Live/Live'), name: 'live' },
    { path: '/video', component: () => import('@/views/Main/Video/Video'), name: 'video' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js